export const ProcessStepLabels = [
  'wizard_steps.choose_package',
  'wizard_steps.vehicle_data',
  'wizard_steps.contract_data',
  'wizard_steps.payment_data',
  'wizard_steps.thank_you'
]
